import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from 'vue';

// Props
interface Props {
  classes: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentConditionPill',
  props: {
    classes: { default: () => [' bg-primary-blue', 'text-white'] }
  },
  setup(__props: any) {

const props = __props as { classes: string[] };





return { __sfc: true,props }
}

})